const cleanPhoneNumber = (phoneNumber: string) => {
  return phoneNumber.replace(/\D/g, '');
};

export default cleanPhoneNumber;
